<template>
  <v-card class="mx-auto mt-1" min-width="1280px" max-width="100vw" outlined>
    <v-row
      class="mx-0 mt-0 white--text"
      style="background-color:#142E57;font-size:22px;height: 260px"
    >
      <v-col cols="7">
        <v-row class="mt-0">
          <v-col class="pl-10 display-1 text-center"
            >สถานการณ์อุบัติเหตุบนโครงข่ายของกระทรวงคมนาคม</v-col
          >
        </v-row>
        <v-row class="justify-center align-center mt-4"
          ><!-- remove mt-4 when compare-->
          <v-col cols="3"></v-col
          ><!-- cols="3" when compare-->
          <v-col cols="3">
            <DatePicker
              v-model="startDate"
              :max="today"
              @input="changeDate(utils.startDateChanged(startDate, endDate), false)"
              :defaultDate="startDate"
              ref="startDate"
              :invert="true"
              bgColor="#4C5E7C"
              :hideclearbtn="true"
            />
          </v-col>
          <v-col cols="1" class="text-center">ถึง</v-col>
          <v-col cols="3">
            <DatePicker
              v-model="endDate"
              :max="today"
              @input="changeDate(utils.endDateChanged(startDate, endDate), false)"
              :defaultDate="endDate"
              ref="endDate"
              :invert="true"
              bgColor="#4C5E7C"
              :hideclearbtn="true"
            />
          </v-col>
          <v-col cols="2"> </v-col>
        </v-row>
        <v-row class="justify-center align-center">
          <v-col cols="3" class="text-right">เปรียบเทียบกับ</v-col>
          <v-col cols="3">
            <DatePicker
              v-model="compareStartDate"
              :max="today"
              @input="changeDate(utils.startDateChanged(compareStartDate, compareEndDate), true)"
              :defaultDate="compareStartDate"
              ref="compareStartDate"
              :invert="true"
              bgColor="#4C5E7C"
              :hideclearbtn="true"
            />
          </v-col>
          <v-col cols="1" class="text-center">ถึง</v-col>
          <v-col cols="3">
            <DatePicker
              v-model="compareEndDate"
              :max="today"
              @input="changeDate(utils.endDateChanged(compareStartDate, compareEndDate), true)"
              :defaultDate="compareEndDate"
              ref="compareEndDate"
              :invert="true"
              bgColor="#4C5E7C"
              :hideclearbtn="true"
            />
          </v-col>
          <v-col cols="2">
            <v-btn
              color="white"
              @click="
                getCompareAccident();
                getMostAccidentRoute();
              "
              >ตกลง</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3" class="d-flex align-center justify-center">
        <span style="font-size:84px">TRAMS</span>
      </v-col>
      <v-col
        cols="2"
        class="py-0 mt-0 pt-0"
        style="background-color:#881300;position:absolute;top:0px;right:16px;border-radius:0px 0px 20px 20px;width:auto"
      >
        <v-row class="mt-0">
          <v-col
            class="d-flex align-center justify-center"
            style="background-color:#E2D8CE;border-radius:0px 0px 20px 20px;height:280px;"
          >
            <v-img
              max-width="240"
              max-height="240"
              :src="require(`@/assets/sumdashboard/All/weblogo.png`)"
            ></v-img>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="text-center mx-0" style="background-color:#BFBFBF">
      <v-col class="display-1">ภาพรวมสถานการณ์อุบัติเหตุทางน้ำ</v-col>
    </v-row>
    <v-row class="mx-0 d-flex" style="background-color:#46352D;">
      <v-col
        cols="4"
        :style="item.bgColor"
        class="align-center d-flex py-4"
        v-bind:class="{ 'white--text': item.invert }"
        v-for="(item, i) in compareAccident"
        :key="i"
      >
        <v-row class="pl-5 py-0">
          <v-col cols="3" class="d-flex align-center justify-center">
            <v-img max-width="84" max-height="84" :src="item.img"></v-img>
          </v-col>
          <v-col cols="8">
            <v-row>
              <v-col cols="12" class="d-flex flex-column justify-center">
                <div class="text-h4 text-center">{{ item.text }}</div>
              </v-col>
            </v-row>
            <v-row class="py-2">
              <v-col cols="5" class="headline text-wrap py-1">ปี {{ item.thisYear }}</v-col>
              <v-col cols="7">
                <v-row class="d-flex">
                  <v-col
                    cols="7"
                    class="headline text-wrap font-weight-medium py-1 text-center accident-year-count black--text"
                  >
                    {{ item.thisYearAmount || '-' }}
                  </v-col>
                  <v-col cols="5" class="headline text-wrap font-weight-medium py-1 text-center">{{
                    item.unit
                  }}</v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="5" class="headline text-wrap py-1">ปี {{ item.lastYear }}</v-col>
              <v-col cols="7">
                <v-row class="d-flex">
                  <v-col
                    cols="7"
                    class="headline text-wrap font-weight-medium py-1 text-center accident-year-count black--text"
                  >
                    {{ item.lastYearAmount || '-' }}
                  </v-col>
                  <v-col cols="5" class="headline text-wrap font-weight-medium py-1 text-center">{{
                    item.unit
                  }}</v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-col cols="12" class="pt-8 pl-0 d-flex flex-column justify-center">
              <div class="title">
                {{ item.countText + '&nbsp;&nbsp;' + (item.decreaseAmount || '-') + '&nbsp;&nbsp;' + item.unit 
                  + '&nbsp;&nbsp;(' + item.decreasePercentage + ')' }}
              </div>
            </v-col>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="text-center mx-0" style="background-color:#BFBFBF">
      <v-col cols="5" class="bottom-header">บริเวณที่เกิดอุบัติเหตุสูงสุด 5 อันดับ</v-col>
      <v-col class="bottom-header">สถานที่เกิดอุบัติเหตุสูงสุด 3 อันดับ</v-col>
      <v-col class="bottom-header">สาเหตุการเกิดอุบัติเหตุสูงสุด 3 อันดับ</v-col>
      <!-- <v-col class="bottom-header">ระดับของเหตุการณ์สูงสุด 3 อันดับ</v-col> -->
    </v-row>
    <v-row class="text-center mx-0 mb-0" style="background-color:white">
      <v-col cols="5" class="px-0 py-0 bottom-content">
        <v-simple-table class="card-border" style="border-bottom:none!important">
          <thead style="background-color:#83C4D8">
            <tr>
              <th class="text-center font-weight-regular">ลำดับ</th>
              <th class="text-center font-weight-regular">สถานที่เกิดอุบัติเหตุ</th>
              <th class="text-center font-weight-regular">ชนิด</th>
              <th class="text-center font-weight-regular">ครั้ง</th>
              <th class="text-center font-weight-regular">ผู้เสียชีวิต</th>
              <th class="text-center font-weight-regular">ผู้บาดเจ็บ</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in mostAccidentRoad" :key="item.order">
              <td>{{ item.order }}</td>
              <td>{{ item.routeName }}</td>
              <td>{{ item.type }}</td>
              <td>{{ item.accident || '-' }}</td>
              <td>{{ item.dead || '-' }}</td>
              <td>{{ item.injury || '-' }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
      <v-col class="text-center mx-0 bottom-content" style="background-color:white">
        <v-col v-if="!typeByOrder || typeByOrder.length == 0" class="bottom-header">ไม่พบข้อมูล</v-col>
        <div
          v-for="(item, index) in typeByOrder"
          :key="index"
          style="height:107px"
          class="d-flex flex-column"
        >
          <v-row class="mt-1 d-flex align-center justify-center">
            <v-col cols="7" class="py-1 d-flex align-center justify-center">
              <v-img max-width="48" max-height="48" :src="item.img"></v-img>
            </v-col>
            <v-col
              cols="5"
              class="py-1 d-flex align-center justify-center title font-weight-regular"
            >
              {{ item.amount || '-' }} ครั้ง
            </v-col>
            <!-- <v-row class="d-flex body-2 align-center justify-center">{{ item.name }}</v-row> -->
          </v-row>
          <v-row class="d-flex align-center justify-center">
            <v-col
              cols="7"
              class="py-1 body-2 d-flex align-center justify-center title font-weight-regular"
            >
              {{ item.name }}
            </v-col>
            <v-col
              cols="5"
              class="py-1 d-flex align-center justify-center title font-weight-regular"
            >
              {{ item.percentage }}
            </v-col>
            <!-- <v-col cols="8" class="text-center py-1">
            <v-row class="d-flex align-center justify-center mb-6">{{ item.amount }} ครั้ง</v-row>
            <v-row class="d-flex align-center justify-center">{{ item.percentage }}</v-row>
          </v-col> -->
          </v-row>
          <v-divider v-if="index != Object.keys(typeByOrder).length - 1"></v-divider>
        </div>
      </v-col>
      <v-col class="text-center mx-0 bottom-content" style="background-color:white">
        <v-col v-if="!causeByOrder || causeByOrder.length == 0" class="bottom-header">ไม่พบข้อมูล</v-col>
        <div
          v-for="(item, index) in causeByOrder"
          :key="index"
          style="height:107px"
          class="d-flex flex-column"
        >
          <v-row class="mt-1 d-flex align-center justify-center">
            <v-col cols="7" class="py-1 d-flex align-center justify-center">
              <v-img max-width="48" max-height="48" :src="item.img"></v-img>
            </v-col>
            <v-col
              cols="5"
              class="py-1 d-flex align-center justify-center title font-weight-regular"
            >
              {{ item.amount || '-' }} ครั้ง
            </v-col>
            <!-- <v-row class="d-flex body-2 align-center justify-center">{{ item.name }}</v-row> -->
          </v-row>
          <v-row class="mt-0 d-flex align-center justify-center">
            <v-col
              cols="7"
              class="py-1 body-2 d-flex align-center justify-center title font-weight-regular"
            >
              {{ item.name }}
            </v-col>
            <v-col
              cols="5"
              class="py-1 d-flex align-center justify-center title font-weight-regular"
            >
              {{ item.percentage }}
            </v-col>
            <!-- <v-col cols="8" class="text-center py-1">
            <v-row class="d-flex align-center justify-center mb-6">{{ item.amount }} ครั้ง</v-row>
            <v-row class="d-flex align-center justify-center">{{ item.percentage }}</v-row>
          </v-col> -->
          </v-row>
          <v-divider v-if="index != Object.keys(causeByOrder).length - 1"></v-divider>
        </div>
      </v-col>
      <!-- <v-col class="text-center mx-0 bottom-content" style="background-color:white">
        <div v-for="(item, index) in classByOrder" :key="item" style="height:107px" class="d-flex flex-column">
        <v-row class="d-flex align-center justify-center">
          <v-col cols="7" class="py-1 d-flex align-center justify-center">
            <v-img
              max-width="48"
              max-height="48"
              :src="item.img"
            ></v-img>
          </v-col>
          <v-col cols="5" class="py-1 d-flex align-center justify-center title font-weight-regular">
            {{ item.amount || '-' }} ครั้ง
          </v-col>
            <v-row class="d-flex body-2 align-center justify-center">{{ item.name }}</v-row>
        </v-row>
        <v-row class="mt-0 d-flex align-center justify-center">
          <v-col cols="7" class="py-1 body-2 d-flex align-center justify-center title font-weight-regular">
            {{ item.name }}
          </v-col>
          <v-col cols="5" class="py-1 d-flex align-center justify-center title font-weight-regular">
            {{ item.percentage }}
          </v-col>
          <v-col cols="8" class="text-center py-1">
            <v-row class="d-flex align-center justify-center mb-6">{{ item.amount }} ครั้ง</v-row>
            <v-row class="d-flex align-center justify-center">{{ item.percentage }}</v-row>
          </v-col>
          
        </v-row>
        <v-divider v-if="index != Object.keys(classByOrder).length - 1" ></v-divider>
        </div>
       </v-col> -->
    </v-row>
  </v-card>
</template>

<script>
import DatePicker from '../global/DatePicker';

export default {
  name: 'ExecutiveWaterReport',
  components: {
    DatePicker
  },
  data: () => ({
    today: null,
    compareStartDate: null,
    compareEndDate: null,
    startDate: null,
    endDate: null,
    compareAccident: [
      {
        img: require('@/assets/sumdashboard/water/ship__5_@2x.png'),
        text: 'อุบัติเหตุ',
        countText: 'ลดลง',
        unit: 'ครั้ง',
        decreaseAmount: 0,
        decreasePercentage: 0.0,
        thisYearAmount: 0,
        lastYearAmount: 0,
        bgColor: 'background-color:#142D58;',
        invert: true
      },
      {
        img: require('@/assets/sumdashboard/road/dead@2x.png'),
        text: 'ผู้เสียชีวิต',
        countText: 'ลดลง',
        unit: 'คน',
        decreaseAmount: 0,
        decreasePercentage: 0.0,
        thisYearAmount: 0,
        lastYearAmount: 0,
        bgColor: 'background-color:#3479A8',
        invert: false
      },
      {
        img: require('@/assets/sumdashboard/road/man_with_arm_injury@2x.png'),
        text: 'ผู้บาดเจ็บ',
        countText: 'ลดลง',
        unit: 'คน',
        decreaseAmount: 0,
        decreasePercentage: 0.0,
        thisYearAmount: 0,
        lastYearAmount: 0,
        bgColor: 'background-color:#83C4D8;',
        invert: false
      }
    ],
    mostAccidentRoad: [],
    typeByOrder: [],
    causeByOrder: [],
    sumAccident: 0,
    isInitial: true
  }),
  created() {},
  mounted() {
    const period = JSON.parse(localStorage.getItem('execParams'));
    if (period) {
      localStorage.removeItem('execParams');
      this.$refs.startDate.setDefaultData(period.startDate);
      this.$refs.endDate.setDefaultData(period.endDate);
      period.startDate = period.startDate.split('-');
      period.endDate = period.endDate.split('-');
      const startDateYear = Number(period.startDate.splice(0, 1)[0]);
      const endDateYear = Number(period.endDate.splice(0, 1)[0]);
      this.$refs.compareStartDate.setDefaultData((startDateYear - 1) + '-' + period.startDate.join('-'));
      this.$refs.compareEndDate.setDefaultData((endDateYear - 1) + '-' + period.endDate.join('-'));
      for (let i = 0; i < this.compareAccident.length; i++) {
        this.compareAccident[i].thisYear = endDateYear + 543;
        this.compareAccident[i].lastYear = endDateYear - 1 + 543;
      }
      this.getCompareAccident();
      this.getMostAccidentRoute();
    }
    else {
      const date = this.utils.getLocalDate();
      this.today = date;
      this.compareStartDate = date;
      this.compareEndDate = date;
      this.startDate = date;
      this.endDate = date;
      for (let i = 0; i < this.compareAccident.length; i++) {
        this.compareAccident[i].thisYear = Number(date.split('-')[0]) + 543;
        this.compareAccident[i].lastYear = Number(date.split('-')[0]) + 543;
      }
      this.getDefaultFestival();
    }
  },
  methods: {
    getDefaultFestival() {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/festival/default`;
      this.axios.get(url).then(response => {
        const res = response.data.data;
        const defaultfes = res.filter(member => {
          return member.isdefault;
        })[0];
        this.startDate = defaultfes.start_date.split(' ')[0];
        this.endDate = defaultfes.end_date.split(' ')[0];
        if (defaultfes.compare_start_date) {
          this.compareStartDate = defaultfes.compare_start_date.split(' ')[0];
        } else {
          const td = new Date(this.startDate);
          td.setFullYear(td.getFullYear() - 1);
          this.compareStartDate = this.utils.getLocalDate(td);
        }
        if (defaultfes.compare_end_date) {
          this.compareEndDate = defaultfes.compare_end_date.split(' ')[0];
        } else {
          const td = new Date(this.endDate);
          td.setFullYear(td.getFullYear() - 1);
          this.compareEndDate = this.utils.getLocalDate(td);
        }
        this.getCompareAccident();
        this.getMostAccidentRoute();
      });
    },
    getCompareAccident() {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/main/dashboard/summary/water`;
      this.axios
        .get(url, {
          params: {
            start_date: this.startDate,
            end_date: this.endDate,
            compare_start_date: this.compareStartDate,
            compare_end_date: this.compareEndDate,
            report_date:this.utils.getLocalDate(),
          }
        })
        .then(response => {
          const res = response.data.data.statistic;
          this.sumAccident = response.data.data.accident.summary;
          this.compareAccident.forEach(element => {
            element.thisYear = res.current_year;
            element.lastYear = res.compare_year;
          });

          this.compareAccident[0].decreaseAmount = Math.abs(
            res.accident_count.compare - res.accident_count.current
          );
          if (res.accident_count.compare > res.accident_count.current) {
            res.accident_count.percentage = res.accident_count.percentage.replace('-', '');
            this.compareAccident[0].countText = 'ลดลง';
          } else this.compareAccident[0].countText = 'เพิ่มขึ้น';
          this.compareAccident[0].decreasePercentage = res.accident_count.percentage;
          this.compareAccident[0].thisYearAmount = res.accident_count.current;
          this.compareAccident[0].lastYearAmount = res.accident_count.compare;

          this.compareAccident[1].decreaseAmount = Math.abs(
            res.dead_amount.compare - res.dead_amount.current
          );
          if (res.dead_amount.compare > res.dead_amount.current) {
            res.dead_amount.percentage = res.dead_amount.percentage.replace('-', '');
            this.compareAccident[1].countText = 'ลดลง';
          } else this.compareAccident[1].countText = 'เพิ่มขึ้น';
          this.compareAccident[1].decreasePercentage = res.dead_amount.percentage;
          this.compareAccident[1].thisYearAmount = res.dead_amount.current;
          this.compareAccident[1].lastYearAmount = res.dead_amount.compare;

          this.compareAccident[2].decreaseAmount = Math.abs(
            res.injury_amount.compare - res.injury_amount.current
          );
          if (res.injury_amount.compare > res.injury_amount.current) {
            res.injury_amount.percentage = res.injury_amount.percentage.replace('-', '');
            this.compareAccident[2].countText = 'ลดลง';
          } else this.compareAccident[2].countText = 'เพิ่มขึ้น';
          this.compareAccident[2].decreasePercentage = res.injury_amount.percentage;
          this.compareAccident[2].thisYearAmount = res.injury_amount.current;
          this.compareAccident[2].lastYearAmount = res.injury_amount.compare;

          this.getTypeByOrder();
          this.getCauseByOrder();
        });
    },
    getMostAccidentRoute() {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/executive/water/list`;
      this.mostAccidentRoad = [];
      for (let i = 1; i <= 5; i++) {
        this.mostAccidentRoad.push({
          order: i,
          routeName: null,
          type: null,
          accident: 0,
          dead: 0,
          injury: 0
        });
      }
      this.axios
        .get(url, {
          params: {
            start_date: this.startDate,
            end_date: this.endDate,
            hasname: true,
            report_date:this.utils.getLocalDate(),
          }
        })
        .then(response => {
          const res = response.data.data;
          this.mostAccidentRoad.forEach((element, i) => {
            if (!(i in res)) {
              element.routeName = '-';
              element.type = '-';
            } else {
              element.routeName = res[i].route_name ? res[i].route_name : '-';
              element.type = res[i].type ? res[i].type : '-';
              element.accident = res[i].accident;
              element.dead = res[i].dead;
              element.injury = res[i].injury;
            }
          });
          this.isInitial = false;
        });
    },
    getTypeByOrder() {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/dashboard/network/water`;
      this.typeByOrder = [];
      this.axios
        .get(url, {
          params: {
            start_date: this.startDate,
            end_date: this.endDate,
            report_date:this.utils.getLocalDate(),
          }
        })
        .then(response => {
          const res = response.data.data;
          const accident_count = [];
          let i;
          for (i in res) {
            if (res[i].amount > 0) accident_count[i] = res[i].amount;
          }
          accident_count.sort();
          accident_count.reverse();
          let index;
          for (index in accident_count) {
            switch (index) {
              case 'sea':
                var item = {
                  name: 'ทะเล',
                  amount: accident_count[index],
                  percentage: `${((accident_count[index] / this.sumAccident) * 100).toFixed(2)}%`,
                  img: require('@/assets/sumdashboard/water/sunset__1_@2x.png')
                };
                break;
              case 'river':
                var item = {
                  name: 'แม่น้ำ',
                  amount: accident_count[index],
                  percentage: `${((accident_count[index] / this.sumAccident) * 100).toFixed(2)}%`,
                  img: require('@/assets/sumdashboard/water/river@2x.png')
                };
                break;
              case 'canal':
                var item = {
                  name: 'คลอง',
                  amount: accident_count[index],
                  percentage: `${((accident_count[index] / this.sumAccident) * 100).toFixed(2)}%`,
                  img: require('@/assets/sumdashboard/water/canal@2x.png')
                };
                break;
            }
            this.typeByOrder.push(item);
          }
        });
    },
    getCauseByOrder() {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/executive/water/cause_by_order`;
      this.causeByOrder = [];
      this.axios
        .get(url, {
          params: {
            start_date: this.startDate,
            end_date: this.endDate,
            report_date:this.utils.getLocalDate(),
          }
        })
        .then(response => {
          const res = response.data.data;
          res.forEach((element, i) => {
            if (i < 3) {
              var item = {
                name: element.name,
                amount: element.accident,
                percentage: `${((element.accident / this.sumAccident) * 100).toFixed(2)}%`,
                img: require('@/assets/sumdashboard/white_image.png')
              };
            }
            this.causeByOrder.push(item);
          });
        });
    },
    changeDate(period, compare) {
      if (period) {
        if (compare) {
          if (period.startDate != this.compareStartDate) {
            this.$refs.compareStartDate.setDefaultData(period.startDate);
          }
          if (period.endDate != this.compareEndDate) {
            this.$refs.compareEndDate.setDefaultData(period.endDate);
          }
        } else {
          if (period.startDate != this.startDate) {
            this.$refs.startDate.setDefaultData(period.startDate);
          }
          if (period.endDate != this.endDate) {
            this.$refs.endDate.setDefaultData(period.endDate);
          }
        }
      }
    }
  },
  watch: {
    // startDate() {
    //   if(!this.isInitial) {
    //     this.getCompareAccident();
    //     this.getMostAccidentRoute();
    //   }
    // },
    // endDate() {
    //   if(!this.isInitial) {
    //     this.getCompareAccident();
    //     this.getMostAccidentRoute();
    //   }
    // },
    // compareStartDate() {
    //   if(!this.isInitial) {
    //     this.getCompareAccident();
    //   }
    // },
    // compareEndDate() {
    //   if(!this.isInitial) {
    //     this.getCompareAccident();
    //   }
    // },
  }
};
</script>

<style scoped>
.inverted {
  -webkit-filter: invert(100%);
  filter: invert(100%);
}

.bottom-header:first-of-type {
  border: 1px solid #3479a8;
}
.bottom-header {
  border: 1px solid #3479a8;
  border-left: none;
  font-size: 24px;
}
.bottom-content:first-of-type {
  border: 1px solid #3479a8;
  border-top: none;
}
.bottom-content {
  border: 1px solid #3479a8;
  border-top: none;
  border-left: none;
}
.accident-year-count {
  background-color: #bfbfbf;
  border-radius: 5px;
}
</style>
